"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;

var _styles = require("@material-ui/core/styles");

var _colors = require("@material-ui/core/colors");

var styles = {
  typography: {
    useNextVariants: true
  },
  fontFamily: 'Roboto, Lato, Arial, sans-serif',
  palette: {
    primary: {
      main: _colors.blue[500],
      contrastDefaultColor: 'light'
    },
    secondary: {
      main: _colors.grey[600],
      light: _colors.grey[500],
      contrastDefaultColor: 'dark'
    },
    error: {
      main: _colors.pink[500],
      contrastDefaultColor: 'light'
    },
    brandPrimary: {
      main: _colors.blueGrey[700],
      contrastDefaultColor: 'light'
    },
    brandPrimaryLight: {
      main: _colors.blueGrey[50],
      contrastDefaultColor: 'dark'
    },
    alert: {
      main: _colors.amber[600],
      contrastDefaultColor: 'dark'
    },
    success: {
      main: '#00c853',
      contrastDefaultColor: 'dark'
    },
    text: {
      main: _colors.grey[900]
    },
    paper: {
      main: '#FFFFFF',
      contrastDefaultColor: 'dark'
    },
    background: {
      main: _colors.grey[50],
      contrastDefaultColor: 'dark'
    }
  },
  spacing: {
    centerContentMaxWidth: 1250
  },
  overrides: {
    MuiAppBar: {
      colorPrimary: {
        backgroundColor: _colors.blueGrey[800]
      }
    },
    MuiButton: {
      text: {
        fontFamily: "'Open Sans', Roboto, Lato, Arial, sans-serif"
      },
      textSecondary: {
        color: _colors.pink[500],
        backgroundColor: 'white',
        '&:hover': {
          backgroundColor: _colors.pink[50]
        }
      }
    },
    MuiTypography: {
      button: {
        fontSize: 14,
        lineHeight: 1.14,
        fontWeight: 500
      },
      caption: {
        fontSize: 12,
        lineHeight: 1.3,
        fontWeight: 400,
        color: _colors.grey[700]
      },
      body1: {
        fontSize: 16,
        lineHeight: 1.5,
        fontWeight: 400
      },
      body2: {
        fontSize: 14,
        lineHeight: 1.71,
        fontWeight: 400
      },
      subtitle1: {
        fontSize: 16,
        lineHeight: 1.5,
        fontWeight: 400
      },
      subtitle2: {
        fontFamily: 'Open sans, Roboto, Lato, Arial, sans-serif',
        fontSize: 14,
        lineHeight: 1.71,
        fontWeight: 600
      },
      h6: {
        fontSize: 20,
        lineHeight: 1.6,
        fontWeight: 700,
        fontFamily: 'Open sans, Roboto, Lato, Arial, sans-serif'
      },
      h5: {
        fontFamily: 'Open sans, Roboto, Lato, Arial, sans-serif',
        fontSize: 24,
        lineHeight: 1.67,
        fontWeight: 600
      },
      h4: {
        fontFamily: 'Open sans, Roboto, Lato, Arial, sans-serif',
        fontSize: 34,
        lineHeight: 1.41,
        fontWeight: 600
      },
      h3: {
        fontFamily: 'Open sans, Roboto, Lato, Arial, sans-serif',
        fontSize: 20,
        lineHeight: 1.6,
        fontWeight: 600
      },
      h2: {
        fontFamily: 'Open sans, Roboto, Lato, Arial, sans-serif',
        fontSize: 24,
        lineHeight: 1.67,
        fontWeight: 400
      },
      h1: {
        fontFamily: 'Open sans, Roboto, Lato, Arial, sans-serif',
        fontSize: 34,
        lineHeight: 1.41,
        fontWeight: 400
      }
    }
  }
};
var theme = (0, _styles.createMuiTheme)(styles);
exports.theme = theme;